<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'Portfolio Report' }}</strong>
        </div>
        <!-- <div class="col-md-2">
          <download :tableId="'users'" :fileName="'portfolios-details'"></download>
        </div>-->
        <!-- <div class="col-md-1">
          <goback></goback>
        </div>-->
      </div>
    </div>
    <div class="card-body mb-15">
      <div class="row mb5">
        <!-- <div class="row mb5"> -->
        <div class="col-md-10" v-if="fillableData && fillableData.inception && fillableData.inception.inception_date">
          <h3 class="text-center">
            Since Inception
            <small>Date: {{ getDate(fillableData.inception.inception_date) }}</small>
          </h3>
        </div>
        <!-- <div class="col-md-1"></div> -->
        <!-- </div> -->
        <div class="col-md-12" v-if="fillableData && fillableData.inception && fillableData.inception.fundwise">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <div class="row mb5">
              <div class="col-md-10">
                <h4>Fundwise</h4>
              </div>
              <div class="col-md-2">
                <download :tableId="'fundwise'" :fileName="'portfolio-fundwise'"></download>
              </div>
            </div>
            <table class="table" id="fundwise">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in stockTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.inception.fundwise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in stockTableFields" v-bind:key="field.name + index + 'inc'">
                    <span v-if="field.type === 'string'">{{ row[field.title] }}</span>
                    <span v-else>
                      <span v-if="field.type === 'number'">
                        <span v-if="field.unit === '(%)'"> {{ (row[field.title]) ? getFixed(row[field.title] * 100) :
                          getFixed(row[field.title]) }}</span>
                        <span v-else>{{ getFixed(row[field.title]) }}</span>
                      </span>
                      <span v-else>{{ getFixed(row[field.title]) }}</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="text-right text-bold" :colspan="stockTableFields.length">Total</td>
                  <td>{{ getFixed(fillableData.inception.total_latest_value) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6" v-if="fillableData && fillableData.inception && fillableData.inception.sectorwise">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <div class="row mb5">
              <div class="col-md-10">
                <h4>Categorywise</h4>
              </div>
              <div class="col-md-2">
                <download :tableId="'categorywise'" :fileName="'categorywise-inc'"></download>
              </div>
            </div>
            <table class="table" id="categorywise">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in sectorTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.inception.sectorwise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in sectorTableFields" v-bind:key="field.title + index">
                    <span v-if="field.type === 'string'">{{ row[field.title] }}</span>
                    <span v-else>
                      <span v-if="field.type === 'number'">
                        <span v-if="field.unit === '(%)'">{{ (row[field.title]) ? getFixed(row[field.title] * 100) :
                          row[field.title] }}</span>
                        <span v-else>{{ (row[field.title]) ? getFixed(row[field.title]) : row[field.title] }}</span>
                      </span>
                      <span v-else>{{ getCustomLabel(row[field.title]) }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6" v-if="fillableData && fillableData.inception && fillableData.inception.industrywise">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <div class="row mb5">
              <div class="col-md-10">
                <h4>Industry wise</h4>
              </div>
              <div class="col-md-2">
                <download :tableId="'fundtypewise'" :fileName="'industrywise-inc'"></download>
              </div>
            </div>
            <table class="table" id="fundtypewise">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in industryTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.inception.industrywise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in industryTableFields" v-bind:key="field.title + index">
                    <span v-if="field.type === 'string'">{{ (row[field.title]) }}</span>
                    <span v-else>
                      <span v-if="field.type === 'number'">
                        <span v-if="field.unit === '(%)'">{{ (row[field.title]) ? getFixed(row[field.title]) :
                          row[field.title] }}</span>
                        <span v-else>{{ getFixed(row[field.title]) }}</span>
                      </span>
                      <span v-else>{{ getCustomLabel(row[field.title]) }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-11">
              <h4 class="text-left">Returns across time periods <small>(In %)</small></h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'inception-returns'" :fileName="'inception-returns'"></download>
            </div>
          </div>
          <div class="row" v-if="fillableData && fillableData.inception">
            <div class="col-md-12">
              <div class="table-responsive app mb-15" v-dragscroll="true">
                <table id="inception-returns" class="table table-bordered">
                  <thead>
                    <tr>
                      <th></th>
                      <th v-for="(hd, index) in compositeIndex1" :key="'portfolio' + index" class="text-center">
                        {{ hd.name }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr v-for="let port of portfolios.sensex_index[1]"> -->
                    <tr v-if="fillableData.inception.portfolio_index">
                      <td>Portfolio Index</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'portfoliotd' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.inception.portfolio_index[hd.title] * 100) :
                          getFixed(fillableData.inception.portfolio_index[hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.inception.portfolio_index[hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.inception.composite_index">
                      <td>{{ 'Composite Index' }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'Composite' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.inception.composite_index[hd.title] * 100) :
                          getFixed(fillableData.inception.composite_index[hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.inception.composite_index[hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.latest.sensex_index">
                      <td>{{ fillableData.latest.sensex_index[1].ind_type }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'large' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.inception.sensex_index[1][hd.title] * 100) :
                          getFixed(fillableData.inception.sensex_index[1][hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.inception.sensex_index[1][hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.inception.sensex_index">
                      <td>{{ fillableData.inception.sensex_index[0].ind_type }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'bsesen' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.inception.sensex_index[0][hd.title] * 100) :
                          getFixed(fillableData.inception.sensex_index[0][hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.inception.sensex_index[0][hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.inception.sensex_index">
                      <td>{{ fillableData.inception.sensex_index[2].ind_type }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'mid' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.inception.sensex_index[2][hd.title] * 100) :
                          getFixed(fillableData.inception.sensex_index[2][hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.inception.sensex_index[2][hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.inception.sensex_index">
                      <td>{{ fillableData.inception.sensex_index[3].ind_type }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'sm' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.inception.sensex_index[3][hd.title] * 100) :
                          getFixed(fillableData.inception.sensex_index[3][hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.inception.sensex_index[3][hd.title] }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--------------LATEST ------------------->
      <div class="row mb5" v-if="fillableData && fillableData.latest">
        <!-- <div class="row mb5"> -->
        <div class="col-md-10" v-if="fillableData.latest.fundwise">
          <h3 class="text-center">Latest <small v-if="fillableData.latest.fundwise.length">Date:
              {{ (fillableData.latest.fundwise[0].latest_date).split('T')[0] }}</small></h3>
        </div>
        <!-- <div class="col-md-1"></div> -->
        <!-- </div> -->

        <div class="col-md-12" v-if="fillableData.latest.fundwise">
          <div class="row">
            <div class="col-md-11">
              <h4 class="text-left"></h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'latest-portfolio-value'" :fileName="'latest-portfolio-value'"></download>
            </div>
          </div>
          <div class="table-responsive app mb-15" v-dragscroll="true" v-if="fillableData.latest.fundwise">
            <table id="latest-portfolio-value" class="table table-bordered app-inner">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="(field, ind) in stockTableFields1" v-bind:key="'field-' + field.title + ind">{{ field.name
                    }}
                  </th>
                  <th v-if="actions.length > 0">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.latest.fundwise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in stockTableFields1" v-bind:key="field.title">
                    <span v-if="field.type === 'string'">
                      <span v-if="field.title === 'industry_type'">{{ getCustomLabel(row[field.title]) }}</span>
                      <span v-else>{{ row[field.title] }}</span>
                    </span>
                    <span v-else-if="field.type === 'number'">{{ getFixed(row[field.title]) }}</span>
                    <span v-else-if="field.type === 'date'">{{ getDate(row[field.title]) }}</span>
                    <span v-else>{{ row[field.title] }}</span>
                  </td>
                  <td v-if="actions.length > 0">
                    <div class="action-btn-wrapper">
                      <a style="margin:1px 4px" class="btn btn-sm btn-small" :class="action.btnClass"
                        v-for="(action, index) in actions" v-bind:key="index + '-action-' + action.tooltip"
                        @click.prevent="action.callback(row, index, $event)">
                        <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-right text-bold" :colspan="stockTableFields1.length">Total</td>
                  <td>{{ getFixed(fillableData.latest.total_latest_value) }}</td>
                </tr>
              </tbody>
              <tfoot v-if="fillableData.latest.fundwise.length == 0">
                <tr>
                  <td :colspan="(stockTableFields1.length + 1 + actions.length)">
                    <i class="fa fa-info cwhite"></i> No data found.
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <div class="row mb5">
              <div class="col-md-10">
                <h4>Categorywise</h4>
              </div>
              <div class="col-md-2">
                <download :tableId="'categorywise-latest'" :fileName="'categorywise-latest'"></download>
              </div>
            </div>
            <table class="table" id="categorywise-latest">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in sectorTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.latest.sectorwise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in sectorTableFields" v-bind:key="field.title + index">
                    <span v-if="field.type === 'string'">{{ row[field.title] }}</span>
                    <span v-else>
                      <span v-if="field.type === 'number'">
                        <span v-if="field.unit === '(%)'">{{ (row[field.title]) ? getFixed(row[field.title] * 100) :
                          row[field.title] }}</span>
                        <span v-else>{{ (row[field.title]) ? getFixed(row[field.title]) : row[field.title] }}</span>
                      </span>
                      <span v-else>{{ getCustomLabel(row[field.title]) }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <div class="row mb5">
              <div class="col-md-10">
                <h4>Industry wise</h4>
              </div>
              <div class="col-md-2">
                <download :tableId="'fundtypewise-latest'" :fileName="'industrywise-latest'"></download>
              </div>
            </div>
            <table class="table" id="fundtypewise-latest">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in industryTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.latest.industrywise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in industryTableFields" v-bind:key="field.title + index">
                    <span v-if="field.type === 'string'">{{ (row[field.title]) }}</span>
                    <span v-else>
                      <span v-if="field.type === 'number'">
                        <span v-if="field.unit === '(%)'">{{ (row[field.title]) ? getFixed(row[field.title]) :
                          row[field.title] }}</span>
                        <span v-else>{{ getFixed(row[field.title]) }}</span>
                      </span>
                      <span v-else>{{ getCustomLabel(row[field.title]) }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-11">
              <h4 class="text-left">Returns across time periods <small>(In %)</small></h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'latest-returns'" :fileName="'latest-returns'"></download>
            </div>
          </div>
          <div class="row" v-if="fillableData && fillableData.latest && fillableData.latest.portfolio_index">
            <div class="col-md-12">
              <div class="table-responsive app mb-15" v-dragscroll="true">
                <table id="latest-returns" class="table table-bordered">
                  <thead>
                    <tr>
                      <th></th>
                      <th v-for="(hd, index) in compositeIndex1" :key="'portfolio' + index" class="text-center">
                        {{ hd.name }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr v-for="let port of portfolios.sensex_index[1]"> -->
                    <tr v-if="fillableData.latest.portfolio_index">
                      <td>Portfolio Index</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'portfoliotd' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.latest.portfolio_index[hd.title] * 100) :
                          getFixed(fillableData.latest.portfolio_index[hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.latest.portfolio_index[hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.latest.composite_index">
                      <td>{{ 'Composite Index' }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'Composite' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.latest.composite_index[hd.title] * 100) :
                          getFixed(fillableData.latest.composite_index[hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.latest.composite_index[hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.latest.sensex_index">
                      <td>{{ fillableData.latest.sensex_index[1].ind_type }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'large' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.latest.sensex_index[1][hd.title] * 100) :
                          getFixed(fillableData.latest.sensex_index[1][hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.latest.sensex_index[1][hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.latest.sensex_index">
                      <td>{{ fillableData.latest.sensex_index[0].ind_type }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'bsesen' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.latest.sensex_index[0][hd.title] * 100) :
                          getFixed(fillableData.latest.sensex_index[0][hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.latest.sensex_index[0][hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.latest.sensex_index">
                      <td>{{ fillableData.latest.sensex_index[2].ind_type }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'mid' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.latest.sensex_index[2][hd.title] * 100) :
                          getFixed(fillableData.latest.sensex_index[2][hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.latest.sensex_index[2][hd.title] }}</span>
                      </td>
                    </tr>
                    <tr v-if="fillableData.latest.sensex_index">
                      <td>{{ fillableData.latest.sensex_index[3].ind_type }}</td>
                      <td v-for="(hd, index) in compositeIndex1" :key="'sm' + index"
                        :class="{ 'text-right': hd.type === 'numeric' }">
                        <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                          getFixed(fillableData.latest.sensex_index[3][hd.title] * 100) :
                          getFixed(fillableData.latest.sensex_index[3][hd.title]) }}</span>
                        <span v-if="hd.type === 'string'">{{ fillableData.latest.sensex_index[3][hd.title] }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-11">
              <h4>Industrywise (Latest)</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'latest-industry'" :fileName="'latest-industry'"></download>
            </div>
          </div>
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <table id="latest-industry" class="table">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in industryTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.latest.industrywise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in industryTableFields" v-bind:key="field.title + index">
                    <span v-if="field.type === 'string'">{{ (row[field.title]) }}</span>
                    <span v-else>
                      <span v-if="field.type === 'number'">
                        <span v-if="field.unit === '(%)'">{{ (row[field.title]) ? getFixed(row[field.title]) :
                          row[field.title] }}</span>
                        <span v-else>{{ getFixed(row[field.title]) }}</span>
                      </span>
                      <span v-else>{{ getCustomLabel(row[field.title]) }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!------------ CHANGES DATA ------------>
      <div class="row" v-if="fillableData && fillableData.change">
        <div class="col-md-11">
          <h4 class="text-left">Changes in portfolio since inception</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'changes-portfolio-value'" :fileName="'changes-portfolio-value'"></download>
        </div>
      </div>
      <div class="table-responsive app mb-15" v-dragscroll="true">
        <table id="changes-portfolio-value" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in changesTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
              <th v-if="actions.length > 0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in fillableData.change" v-bind:key="'row' + index">
              <td>{{ index + 1 }}</td>
              <td v-for="field in changesTableFields" v-bind:key="field.name">
                <span v-if="field.type === 'string'">
                  <span v-if="field.title === 'industry_type'">{{ getCustomLabel(row[field.title]) }}</span>
                  <span v-else>{{ (row[field.title] !== '') ? row[field.title] : '-' }}</span>
                </span>
                <span v-else-if="field.type === 'number'">{{ (row[field.title] !== '') ? getFixed(row[field.title]) :
                  '-'
                  }}</span>
                <span v-else-if="field.type === 'date'">
                  <span v-if="row['no_of_share_sold'] !== '' && field.title === 'date_of_sale'">{{
                    getDate(row['date_of_sale']) }}</span>
                  <span v-else-if="row['no_of_share_purchased'] !== '' && field.title === 'date_of_purchase'">{{
                    getDate(row['date_of_purchase']) }}</span>
                  <span v-else>-</span>
                  <!-- {{{{getDate(row['date_of_sale'])}}}} -->
                </span>
                <span v-else>{{ (row[field.title] !== '') ? row[field.title] : '-' }}</span>
              </td>
              <td v-if="actions.length > 0">
                <div class="action-btn-wrapper">
                  <a style="margin:1px 4px" class="btn btn-sm btn-small" :class="action.btnClass"
                    v-for="(action, index) in actions" v-bind:key="index + '-action-' + action.tooltip"
                    @click.prevent="action.callback(row, index, $event)">
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData && fillableData.change && fillableData.change.length == 0">
            <tr>
              <td :colspan="(stockTableFields.length + 1 + actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!------------- GRAPH DATA ------------>
      <div class="row mb5">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-11">
              <h4>Graph Data</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'graph-data'" :fileName="'graph-data'"></download>
            </div>
          </div>
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <table id="graph-data" class="table table-bordered"
              v-if="fillableData && fillableData.latest && fillableData.latest.PortfolioIndexGraph">
              <thead>
                <tr>
                  <th></th>
                  <th>Date</th>
                  <th v-for="(hd, index) in graphData" :key="'portfolio-graph' + index" class="text-center">{{ hd.name
                    }}
                  </th>
                </tr>
              </thead>
              <tbody v-for="(port, index) in fillableData.latest.PortfolioIndexGraph" v-bind:key="index + 'pgraph'">
                <tr
                  v-if="port.total_investment && fillableData.latest.sensex_bse[index] && fillableData.latest.sensex_500[index]">
                  <!-- <tr v-if="fillableData.inception.portfolio_index"> -->
                  <td>{{ (index + 1) }}</td>
                  <td>{{ getDate(fixDate(port.date)) }}</td>
                  <td>{{ getFixed(port.total_investment) }}</td>
                  <td>{{ getFixed(port.index) }}</td>
                  <td>
                    <span v-if="sensexDataOri[index]">{{ sensexDataOri[index] }}</span>
                  </td>
                  <td>
                    <span v-if="sensexData[index]">{{ sensexData[index] }}</span>
                  </td>
                  <td>
                    <span v-if="bse500DataOri[index]">{{ bse500DataOri[index] }}</span>
                  </td>
                  <td>
                    <span v-if="bse500Data[index]">{{ bse500Data[index] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../../assets/mixins/common.js";
export default {
  mixins: [commonMixins],
  name: "PortfolioReport",
  created() {
    if (!this.$route.params.id) {
      this.$router.push({ name: "portfolios" });
    }
    console.log("Config ", process.env.API_URL);
    this.portId = this.$route.params.id;
    this.pname = this.$route.params.name;
    this.fetchData();
  },
  data() {
    return {
      pname: "",
      apiUrl: "mutual-funds/portfolio/testing/",
      apiMode: true,
      company: {},
      actions: [],
      searchParams: {},
      sectorData: [],
      stockTableFields1: [
        { title: "sch_name", name: "Scheme Name", type: "string", unit: "" },
        { title: "Category", name: "Category", type: "string", unit: "" },
        { title: "MainCategory", name: "Main Category", type: "string", unit: "" },
        {
          title: "no_of_units_held",
          name: "No of Units held",
          type: "string",
          unit: ""
        },
        {
          title: "LatestNAV",
          name: "Latest NAV",
          type: "number",
          unit: ""
        },
        {
          title: "LatestValue",
          name: "Latest Value",
          type: "number",
          unit: ""
        },
        {
          title: "LV_By_TV",
          name: "LV/TV",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_one_day_price",
          name: "One Day Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_today",
          name: "Today's Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_one_week_price",
          name: "1Week Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_one_month_previous_price",
          name: "1Month Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_three_month_previous_price",
          name: "3Months Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_six_month_previous_price",
          name: "6Months Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_last_year_price",
          name: "1Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_two_year_previous_price",
          name: "2Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_three_year_previous_price",
          name: "3Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_five_year_previous_price",
          name: "5Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_inception_date_price",
          name: "Inception Price",
          type: "number",
          unit: ""
        },
      ],
      stockTableFields: [
        { title: "sch_name", name: "Scheme Name", type: "string", unit: "" },
        { title: "Category", name: "Category", type: "string", unit: "" },
        { title: "MainCategory", name: "Main Category", type: "string", unit: "" },
        {
          title: "no_of_units_held",
          name: "No of Units held",
          type: "string",
          unit: ""
        },
        { title: "latest_date", name: "Latest Date", type: "date", unit: "" },
        {
          title: "NAV",
          name: "NAV",
          type: "number",
          unit: ""
        },
        {
          title: "one_year_return",
          name: "1Yr Return",
          type: "number",
          unit: ""
        },
        {
          title: "latest_price",
          name: "Latest Price",
          type: "number",
          unit: ""
        },
        {
          title: "last_year_price",
          name: "Last Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "no_of_units_purchased",
          name: "No of Units purchased",
          type: "string",
          unit: ""
        },
        {
          title: "no_of_units_sold",
          name: "No of Units sold",
          type: "string",
          unit: ""
        },
        {
          title: "latest_value",
          name: "Latest Value",
          type: "number",
          unit: ""
        },
        {
          title: "latest_value_by_total_value",
          name: "LV/TV",
          type: "number",
          unit: ""
        },
      ],
      sectorTableFields: [
        { title: "sectorname", name: "Category", type: "string", unit: "" },
        {
          title: "latest_value_by_total_value",
          name: "LV/TV",
          type: "number",
          unit: ""
        }
      ],
      mcapTableFields: [
        {
          title: "MainCategory",
          name: "Fund Type",
          type: "string",
          unit: ""
        },
        {
          title: "latest_value_by_total_value",
          name: "LV/TV",
          type: "number",
          unit: ""
        }
      ],
      industryTableFields: [
        {
          title: "ind_type",
          name: "Industry Type",
          type: "string",
          unit: ""
        },
        {
          title: "latest_value_by_total_value",
          name: "LV/TV",
          type: "number",
          unit: ""
        }
      ],
      fillableData: [],
      compositeIndex: [
        // {title: 'ind_type', name: , type: 'numeric', unit: ''},
        { title: "latest", name: "Latest", type: "numeric", unit: "" },
        { title: "one_day", name: "1 Day", type: "numeric", unit: "" },
        { title: "one_week", name: "1 Week", type: "numeric", unit: "" },
        { title: "one_month", name: "1 Month", type: "numeric", unit: "" },
        { title: "three_month", name: "3 Month", type: "numeric", unit: "" },
        { title: "six_month", name: "6 Month", type: "numeric", unit: "" },
        { title: "one_year", name: "1 Year", type: "numeric", unit: "" },
        { title: "two_year", name: "2 Year", type: "numeric", unit: "" },
        { title: "three_year", name: "3 Year", type: "numeric", unit: "" },
        { title: "five_year", name: "5 Year", type: "numeric", unit: "" },
        {
          title: "inception_date",
          name: "Since Inception",
          type: "numeric",
          unit: ""
        }
      ],
      compositeIndex1: [
        // {title: 'ind_type', name: , type: 'numeric', unit: ''},
        // { title: "latest", name: "Latest", type: "numeric", unit: "(%)" },
        { title: "one_day", name: "1 Day", type: "numeric", unit: "(%)" },
        { title: "one_week", name: "1 Week", type: "numeric", unit: "(%)" },
        { title: "one_month", name: "1 Month", type: "numeric", unit: "(%)" },
        { title: "three_month", name: "3 Month", type: "numeric", unit: "(%)" },
        { title: "six_month", name: "6 Month", type: "numeric", unit: "(%)" },
        { title: "one_year", name: "1 Year", type: "numeric", unit: "(%)" },
        { title: "two_year", name: "2 Year", type: "numeric", unit: "(%)" },
        { title: "three_year", name: "3 Year", type: "numeric", unit: "(%)" },
        { title: "five_year", name: "5 Year", type: "numeric", unit: "(%)" },
        {
          title: "inception_date",
          name: "Since Inception",
          type: "numeric",
          unit: "(%)"
        }
      ],
      graphData: [
        { title: "portfolio", name: "Portfolio" },
        { title: "portfolio_index", name: "Portfolio Index" },
        { title: "sensex_bse", name: "BSE Sensex" },
        { title: "sensex_bse_index", name: "BSE Sensex Index" },
        { title: "sensex_500", name: "BSE Sensex 500" },
        { title: "sensex_500_index", name: "BSE Sensex 500 Index" }
      ],
      changesTableFields: [
        { title: "sch_name", name: "Scheme", type: "string", unit: "" },
        // { title: "sectorname", name: "Sector", type: "string", unit: "" },
        // { title: "market_cap", name: "Market Cap", type: "number", unit: "" },
        // { title: "industry_type", name: "MCap Type", type: "string", unit: "" },
        {
          title: "price_per_units",
          name: "Price per Unit",
          type: "number",
          unit: ""
        },
        {
          title: "date_of_purchase",
          name: "Purchase Date",
          type: "date",
          unit: ""
        },
        {
          title: "no_of_units_purchased",
          name: "No of Units purchased",
          type: "string",
          unit: ""
        },
        {
          title: "price_at_which_sold",
          name: "Sell Price",
          type: "number",
          unit: ""
        },
        {
          title: "date_of_sale",
          name: "Sell Date",
          type: "date",
          unit: ""
        },
        {
          title: "no_of_units_sold",
          name: "No of Units sold",
          type: "string",
          unit: ""
        },
        // {
        //   title: "no_of_share_held",
        //   name: "No of stock held",
        //   type: "string",
        //   unit: ""
        // },
        // {
        //   title: "price_no_of_share_inception_date_price",
        //   name: "Value on Inception Date",
        //   type: "number",
        //   unit: ""
        // }
        // {
        //   title: "latest_value",
        //   name: "Latest Value",
        //   type: "number",
        //   unit: ""
        // }
      ],
      sensexData: [],
      bse500Data: [],
      sensexDataOri: [],
      bse500DataOri: []
    };
  },
  methods: {
    fetchData(data) {
      console.log("=====" + this.url + "========");
      let myself = this;
      http.get(this.apiUrl + this.portId, {}, function (
        error,
        response
      ) {
        console.log(response);
        myself.fillableData = response;
        myself.getIndexValues();
      });
    },
    getIndexValues() {
      let myself = this;
      this.fillableData.inception.sensex_bse.forEach((val, key1) => {
        //console.log(val, key);
        // this.groupLabels.push(val["IndexDate"]); //.substring(0, val["my_date"].indexOf("T")));
        myself.fillableData.latest.PortfolioIndexGraph.forEach((port, key2) => {
          if (port.date === val["IndexDate"]) {
            //myself.sensexData.push(val["IndexValue"]);
            myself.sensexData[key2] = val["IndexValue"];
          }
        });
        //myself.sensexData.push(val["IndexValue"]);
      });

      this.fillableData.inception.sensex_500.forEach((val, key3) => {
        // this.groupLabels.push(val["IndexDate"]); //.substring(0, val["my_date"].indexOf("T")));
        myself.fillableData.latest.PortfolioIndexGraph.forEach((port, key4) => {
          if (port.date === val["IndexDate"]) {
            //myself.bse500Data.push(val["IndexValue"]);
            myself.bse500Data[key4] = val["IndexValue"];
          }
        });
        //this.bse500Data.push(val["IndexValue"]);
      });
      this.sensexDataOri = this.sensexData;
      this.bse500DataOri = this.bse500Data;
      this.bse500Data = this.getDataInRatio(this.bse500Data);
      this.sensexData = this.getDataInRatio(this.sensexData);
      //console.log(this.bse500Data, this.sensexData);
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/portfolios/portfolio-test-reports.vue